import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi, type DashboardStats } from '../../api/admin';
import { useAuth } from '../../auth/AuthContext';
import {
  Hero, StatTile, BarChart, Donut, RecentTable, DashSkeleton, compact,
} from '../../components/dashboard';
import { PaymentDetailModal } from '../../components/PaymentDetailModal';

export function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [detail, setDetail] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    adminApi.stats().then(setStats).catch(() => setError('İstatistikler yüklenemedi'));
  }, []);

  if (error) return <div className="auth-error">{error}</div>;
  if (!stats) return <DashSkeleton />;

  const weekTotal = stats.weekly.reduce((s, w) => s + w.value, 0);

  return (
    <div className="dash">
      <div className="dash-head">
        <div>
          <h1>Genel Bakış</h1>
          <p>Hoş geldin {user?.full_name?.split(' ')[0] || 'Yönetici'} — Persaş Tekstil tahsilat özeti.</p>
        </div>
        <button className="dash-cta" onClick={() => navigate('/panel/odemeler')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M8 6h11M8 12h11M8 18h11M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></svg>
          Ödemeleri Yönet
        </button>
      </div>

      <Hero
        eyebrow="Toplam Tahsilat"
        amount={stats.totalCollected}
        delta={stats.collectedDeltaPct}
        weekly={stats.weekly.map((w) => w.value)}
        minis={[
          { label: 'Onaylı Ödeme', value: String(stats.approvedCount) },
          { label: 'Başarı Oranı', value: `%${stats.successRate.toLocaleString('tr-TR')}` },
          { label: 'Aktif Bayi', value: String(stats.dealerCount) },
        ]}
      />

      <div className="dash-stats">
        <StatTile tone="g" icon="check" value={String(stats.approvedCount)} label="Onaylı Ödeme" delta={stats.approvedDeltaPct} />
        <StatTile tone="r" icon="card" value={String(stats.failedCount)} label="Başarısız Ödeme" />
        <StatTile tone="b" icon="bank" value={String(stats.enabledBanks)} label="Aktif Banka" />
      </div>

      <div className="dash-grid">
        <BarChart data={stats.weekly} note={`Bu hafta ${compact(weekTotal)}`} />
        <Donut items={stats.bankDistribution} total={stats.approvedCount} />
      </div>

      <RecentTable rows={stats.recent} showCustomer onRow={(id) => setDetail(id)} />

      <PaymentDetailModal orderId={detail} onClose={() => setDetail(null)} />
    </div>
  );
}
